import {gql} from '@apollo/client'

export const GET_ACCOUNT = gql`
  query GetAccount($accountId: ID!) {
    account(id: $accountId) {
      id
      displayName @client
      name
      contactAddress
      contactFirstName
      contactLastName
      contactEmail
      billingEmail
      contactPhone
      customerNumber
      groups {
        id
        colour
        name
      }
      paymentDetail {
        id
        name
      }
      referralCode
      referredBy {
        id
        displayName @client
        name
        contactFirstName
        contactLastName
      }
      referredByCode
      referredAccounts {
        id
      }
      state
      warnWhenOverdue
      useRunningBalanceInvoices
      xeroLink
      balance
      overdueSince
      overdueAmount
      paymentFrequencyInDays
      createdAt
    }
  }
`

export const CREATE_ACCOUNT = gql`
  mutation CreateOrUpdateAccount($name: String) {
    account(name: $name) {
      id
      displayName @client
      name
      contactAddress
      contactFirstName
      contactLastName
      contactEmail
      billingEmail
      contactPhone
      customerNumber
      groups {
        id
        colour
        name
      }
      paymentDetail {
        id
        name
      }
      state
      warnWhenOverdue
      useRunningBalanceInvoices
      paymentFrequencyInDays
      xeroLink
      balance
      createdAt
      updatedAt
    }
  }
`

export const UPDATE_ACCOUNT = gql`
  mutation CreateOrUpdateAccount(
    $accountId: ID!
    $name: String
    $contactAddress: String
    $contactFirstName: String
    $contactLastName: String
    $contactPhone: String
    $contactEmail: String
    $billingEmail: String
    $customerNumber: String
    $groups: JSON
    $state: String
    $warnWhenOverdue: Boolean
    $useRunningBalanceInvoices: Boolean
    $paymentDetailId: ID
  ) {
    account(
      id: $accountId
      name: $name
      contactAddress: $contactAddress
      contactFirstName: $contactFirstName
      contactLastName: $contactLastName
      contactPhone: $contactPhone
      contactEmail: $contactEmail
      billingEmail: $billingEmail
      customerNumber: $customerNumber
      groups: $groups
      state: $state
      warnWhenOverdue: $warnWhenOverdue
      useRunningBalanceInvoices: $useRunningBalanceInvoices
      paymentDetailId: $paymentDetailId
    ) {
      id
      displayName @client
      name
      contactAddress
      contactFirstName
      contactLastName
      contactEmail
      billingEmail
      contactPhone
      customerNumber
      groups {
        id
        colour
        name
      }
      paymentDetail {
        id
        name
      }
      state
      warnWhenOverdue
      useRunningBalanceInvoices
      xeroLink
      balance
      overdueSince
      overdueAmount
    }
  }
`
